import { Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";

export const thermometerHeight = 400;
export const thermometerWidth = 60;
export const thermometerStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: "relative",
      height: thermometerHeight,
      minWidth: thermometerWidth,
    },
    background: {
      backgroundColor: "#E6ECEE",
      height: thermometerHeight,
      width: thermometerWidth,
      borderRadius: 48,
      position: "absolute",
      bottom: 0,
      zIndex: 0,
    },
    foregroundContainer: {
      position: "absolute",
      left: "50%",
      width: thermometerWidth,
      height: thermometerHeight,
      maxWidth: thermometerWidth,
    },
    foreground: {
      backgroundColor: "#3E4066",
      height: 0,
      width: thermometerWidth,
      position: "absolute",
      marginLeft: "auto",
      marginRight: "auto",
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 1,
      borderBottomRightRadius: 48,
      borderBottomLeftRadius: 48,
      transition: "height 0.5s ease-in-out",
      maxWidth: thermometerWidth,
    },
    hundredBox: {
      position: "absolute",
      top: -22,
      left: "50%",
      fontSize: "16px",
    },
    zeroBox: {
      position: "absolute",
      bottom: -22,
      left: "50%",
      fontSize: "16px",
    },
    absoluteCenter: {
      position: "relative",
      left: "-50%",
    },
    markerContainer: {
      position: "absolute",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 3,
      bottom: 0,
      transition: "bottom 0.3s ease-out",
    },
    markerLine: {
      height: "1px",
      width: "50px",
      backgroundColor: "#5db2e3",
    },
    markerLineShort: {
      width: "20px",
      marginLeft: "30px",
    },
    marker: {
      height: 24,
      width: 24,
      backgroundColor: "#5db2e3",
      color: "white",
      fontWeight: 500,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "24px",
    },
  })
);
